import { StateCreator } from 'zustand';

import { SubmissionStatusState } from './types/SubmissionStatusState';
import { SubmissionStatusStateDependencies } from './types/SubmissionStatusStateDependencies';

export const submissionStatusStore =
  ({
    config,
    useApiStore,
  }: SubmissionStatusStateDependencies): StateCreator<SubmissionStatusState> =>
  (set, get) => ({
    retryFailedSubmissionError: false,
    retryFailedSubmissionIsLoading: false,

    computed: {
      get legacyRequestConfig() {
        // This is used to set the token header for use within the legacy UI
        const token = localStorage.getItem(config.session.CHECKLIGHT_TOKEN_KEY);
        return token ? { headers: { 'X-Access-Token': token } } : {};
      },
    },

    retryFailedSubmission: (vehicleId: string | undefined) => {
      const {
        computed: { legacyRequestConfig },
        setRetryFailedSubmissionError,
        setRetryFailedSubmissionIsLoading,
      } = get();

      if (!vehicleId) {
        setRetryFailedSubmissionError(true);

        return;
      }

      setRetryFailedSubmissionIsLoading(true);

      const portalHttpRequest = useApiStore.getState().portalApi();

      return (
        portalHttpRequest
          .post(
            '/2.0/applicant/retry-failed-submission',
            { vehicleId },
            legacyRequestConfig,
          )
          // The application status should now be updated to `QUEUED_FOR_SUBMISSION`
          // Reload the page so the application will begin polling for status updates.
          .then(() => window.location.reload())
          .catch(() => {
            setRetryFailedSubmissionError(true);

            // Reset loading state only in the event of an error.
            // Attempting to reset within the `finally` block will cause button flickering
            // when the request is successful and the page reloads.
            setRetryFailedSubmissionIsLoading(false);
          })
      );
    },
    setRetryFailedSubmissionError: (value: boolean) => {
      set({ retryFailedSubmissionError: value });
    },
    setRetryFailedSubmissionIsLoading: (value: boolean) => {
      set({ retryFailedSubmissionIsLoading: value });
    },
  });
